// Mirrors ClinicalFlag::COLOR_* constants on the backend.
export const CLINICAL_FLAG_COLOR_DEFAULT = 0;
export const CLINICAL_FLAG_COLOR_GREEN = 1;
export const CLINICAL_FLAG_COLOR_PURPLE = 2;
export const CLINICAL_FLAG_COLOR_BLUE = 3;
export const CLINICAL_FLAG_COLOR_RED = 4;
export const CLINICAL_FLAG_COLOR_ORANGE = 5;

// One entry per color: `marker` is the svg suffix of the alert bullet in the flags modal,
// `button` the classes of the score button in the admissions list. They cannot be derived
// from each other - COLOR_GREEN/RED/ORANGE reuse the bootstrap success/danger/warning
// palette, while purple/blue are custom classes from custom.css.
// COLOR_DEFAULT is deliberately absent: it means "no color configured" and keeps the
// legacy rating/priority based styling of the caller.
const COLOR_STYLES = {
    [CLINICAL_FLAG_COLOR_GREEN]: {marker: 'green', button: 'btn-success10 text-success'},
    [CLINICAL_FLAG_COLOR_PURPLE]: {marker: 'purple', button: 'btn-purple text-purple'},
    [CLINICAL_FLAG_COLOR_BLUE]: {marker: 'blue', button: 'btn-blue10 text-blue'},
    [CLINICAL_FLAG_COLOR_RED]: {marker: 'danger', button: 'btn-danger10 text-danger'},
    [CLINICAL_FLAG_COLOR_ORANGE]: {marker: 'warning', button: 'btn-warning10 text-warning'},
};

/**
 * Resolve the svg classes of a clinical flag marker.
 * An explicitly configured flag color wins; otherwise the caller's legacy
 * rating/priority based fallback is kept.
 *
 * @param item     clinical flag as exported by the API
 * @param fallback {path, symbol} classes used when the flag has no explicit color
 */
export const clinicalFlagColorClasses = (item, fallback) => {
    const style = COLOR_STYLES[item && item.color];
    if (!style) {
        return fallback;
    }
    return {path: `alert-bg-${style.marker}`, symbol: `alert-symbol-${style.marker}`};
};

/**
 * Resolve the button classes of the clinical flags score in the admissions list.
 * The color of the highest priority triggered flag (clinicalFlags_topColor) wins,
 * so e.g. a Respiratory alert paints the button blue regardless of the other flags;
 * without a configured color the caller's legacy rating/priority fallback is kept.
 *
 * @param admission admission as exported by the API
 * @param fallback  css classes used when no triggered flag has an explicit color
 */
export const clinicalFlagScoreButtonClass = (admission, fallback) => {
    const style = COLOR_STYLES[admission && admission.clinicalFlags_topColor];

    return style ? style.button : fallback;
};
